module.exports = __webpack_public_path__ + "img/certificate-IM-5.5-6.5.4aef487e.png";